import React, { useState, useEffect, useRef } from 'react';
// import * as pdfjs from 'pdfjs-dist';
import { jsPDF } from 'jspdf';
import {
    Button,
    Checkbox,
    message
} from "antd";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Service from '../../service';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch } from "react-redux";
import { showAuthLoader, hideAuthLoader } from "../../appRedux/actions/Auth";
import { ReloadOutlined } from '@ant-design/icons';
import "./signatureCanvas.css"
import { React_profile_url } from '../../constants/permission_id';
import noImageFound from "../../assets/images/noImageFound.jpg";


const SignDocs = ({ initialFile = { url: '' }, getEmpDataFunction, isSignedAnyDoc, signForAllDoc }) => {

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery();
    let token = query.get("token");
    const dispatch = useDispatch();
    const [checked, setChecked] = useState(false);
    const [signAttch, setsignAttch] = useState(false)
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const [images, setImages] = useState([]);
    const [uploadedSignature, setUploadedSignature] = useState(null);

    const [isMouseDown, setIsMouseDown] = useState(false);
    const [reloadPDF, setReloadPDF] = useState(false);
    const containerRef = useRef();
    const fileInputRef = useRef();
    const [fileName, setFileName] = useState("");
    const [pdfDoc, setPdfDoc] = useState(null);
    const [isScriptLoaded, setIsScriptLoaded] = useState(false);
    // Initial script loading
    useEffect(() => {
        if (!window.pdfjsLib) {
            const script = document.createElement('script');
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
            script.onload = () => {
                window.pdfjsLib.GlobalWorkerOptions.workerSrc =
                    'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
                setIsScriptLoaded(true);
            };
            document.body.appendChild(script);
            return () => {
                if (document.body.contains(script)) {
                    document.body.removeChild(script);
                }
            };
        } else {
            setIsScriptLoaded(true);
        }
    }, []);

    // Document loading
    useEffect(() => {
        if (isScriptLoaded && initialFile?.url) {
            dispatch(showAuthLoader());
            const loadingTask = window.pdfjsLib.getDocument({ url: initialFile.url });
            loadingTask.promise
                .then((pdf) => {
                    setPdfDoc(pdf);
                    setTotalPages(pdf?.numPages);
                    dispatch(hideAuthLoader());
                })
                .catch((error) => {
                    console.error('Error loading PDF:', error);
                    dispatch(hideAuthLoader());
                });
        }
    }, [isScriptLoaded, initialFile.url, reloadPDF]);

    // Page rendering
    useEffect(() => {
        if (pdfDoc) {
            renderPage(pdfDoc, currentPage);
        }
    }, [pdfDoc, currentPage, images]);

    useEffect(() => { setCurrentPage(1); }, [initialFile.url])


    const renderPage = (pdf, pageNumber) => {
        dispatch(showAuthLoader());
        pdf.getPage(pageNumber).then((page) => {
            const scale = 1.2;
            const viewport = page.getViewport({ scale });
            const canvas = containerRef.current;
            const context = canvas.getContext('2d');
            context.clearRect(0, 0, canvas.width, canvas.height);
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            const renderContext = {
                canvasContext: context,
                viewport: viewport,
            };

            const renderTask = page.render(renderContext);
            renderTask.promise
                .then(() => {
                    canvas.style.width = '100%';
                    canvas.style.height = 'auto';
                    containerRef.current.style.width = '100%';
                    containerRef.current.style.height = 'auto';

                    images.forEach((img) => {
                        if (img.page === pageNumber) {
                            const image = new Image();
                            image.onload = () => {
                                context.drawImage(image, img.x, img.y, 160, 80);
                            };
                            image.onerror = () => {
                                image.src = noImageFound;
                            };
                            image.src = img.src;
                        }
                    });
                    dispatch(hideAuthLoader());

                })
                .catch((error) => {
                    dispatch(hideAuthLoader());
                    console.error(error)
                });
        });
    };

    const fixImage = async () => {
        dispatch(showAuthLoader());
        if (uploadedSignature) {
            try {
                const canvas = containerRef.current;
                const rect = canvas.getBoundingClientRect();
                const x = (position.left * canvas.width) / rect.width;
                const y = (position.top * canvas.height) / rect.height;

                // Convert blob URL to base64 data URL before storing
                const base64DataUrl = await convertToBase64(uploadedSignature);

                setImages((prevImages) => [
                    ...prevImages,
                    {
                        src: base64DataUrl, // Store as base64 instead of blob URL
                        x: x,
                        y: y,
                        page: currentPage,
                    },
                ]);
                setUploadedSignature(null);
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
                // setUploadedSignature(localStorage.getItem('signatu')) // Removed auto-reappear
                setsignAttch(true)
            } catch (error) {
                console.error('Error converting signature to base64:', error);
                message.error('Failed to save signature. Please try again.');
            }
        }
        dispatch(hideAuthLoader());

    };

    const uploadSignedPDF = async (values, fileName, file) => {
        try {
            dispatch(showAuthLoader());
            let docFormData = new FormData()
            docFormData.append('signDoc', file, fileName)
            docFormData.append('doc_type', values.doc_Type)
            docFormData.append('doc_name', fileName)
            docFormData.append('uniqueId', values.uniqueId)

            const response = await Service.makeAPICall({
                methodName: Service.postMethod,
                api_url: `${Service.signDocsByEmployee}/${token}`,
                body: docFormData,
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (response.data && response.data.data) {
                await getEmpDataFunction()
                dispatch(hideAuthLoader());
            }
            else {
                message.error(response.data.message)
                dispatch(hideAuthLoader());
            }
        } catch (error) {
            console.log(error);
            dispatch(hideAuthLoader());

        }
    };

    const handleCanvasMouseDown = (e) => {
        if (uploadedSignature && e.target.tagName === 'IMG') {
            setIsMouseDown(true);
        }
    };

    const handleCanvasMouseUp = (e) => {
        setIsMouseDown(false);
    };

    const handleCanvasMouseMove = (e) => {
        if (isMouseDown && uploadedSignature) {
            const bounds = containerRef.current.getBoundingClientRect();
            let newTop = e.clientY - bounds.top - 25;
            let newLeft = e.clientX - bounds.left - 50;

            if (newTop < 0) newTop = 0;
            if (newLeft < 0) newLeft = 0;
            if (newTop + 80 > bounds.height) newTop = bounds.height - 80;
            if (newLeft + 160 > bounds.width) newLeft = bounds.width - 160;

            setPosition({
                top: newTop,
                left: newLeft,
            });
        }
    };

    const [fileError, setFileError] = useState('');

    // Helper function to convert blob URL or file to base64 data URL
    const convertToBase64 = (blobUrl) => {
        return new Promise((resolve, reject) => {
            // If it's already a data URL, return it
            if (blobUrl && blobUrl.startsWith('data:')) {
                resolve(blobUrl);
                return;
            }

            // If it's a blob URL, fetch it and convert to base64
            if (blobUrl && blobUrl.startsWith('blob:')) {
                fetch(blobUrl)
                    .then(response => response.blob())
                    .then(blob => {
                        const reader = new FileReader();
                        reader.onloadend = () => resolve(reader.result);
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    })
                    .catch(reject);
            } else {
                reject(new Error('Invalid URL format'));
            }
        });
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file && ['image/jpeg', 'image/png', 'image/svg+xml'].includes(file.type)) {
            setFileError('');

            const blobUrl = URL.createObjectURL(file);
            setUploadedSignature(blobUrl);

            // Convert to base64 and store in localStorage for persistence
            const reader = new FileReader();
            reader.onloadend = () => {
                localStorage.setItem('signatu', reader.result);
            };
            reader.readAsDataURL(file);

            setPosition({ top: 50, left: 50 });
            setFileName(e.target.files[0].name);
        } else {
            setFileError('File format not supported!');
            setFileName("");
        }
    };





    //Download PDF function:
    const downloadPDF = async () => {
        if (images.length == 0) {
            message.error("Please upload your signature")
            return;
        }
        dispatch(showAuthLoader());
        try {
            // Pre-convert any blob URLs to base64 data URLs to ensure they're valid
            const convertedImages = await Promise.all(
                images.map(async (img) => {
                    if (img.src && img.src.startsWith('blob:')) {
                        try {
                            const base64Url = await convertToBase64(img.src);
                            return { ...img, src: base64Url };
                        } catch (error) {
                            console.error('Failed to convert blob URL to base64:', error);
                            // Return original if conversion fails - will be handled in image loading
                            return img;
                        }
                    }
                    return img;
                })
            );

            const pdfDoc = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4' });
            const loadingTask = window.pdfjsLib.getDocument(initialFile.url);

            const pdf = await loadingTask.promise;
            const promises = [];

            for (let i = 1; i <= totalPages; i++) {
                promises.push(
                    pdf.getPage(i).then((page) => {
                        const scale = 1.2;
                        const viewport = page.getViewport({ scale });
                        const canvas = document.createElement('canvas');
                        const context = canvas.getContext('2d');
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;

                        const renderContext = {
                            canvasContext: context,
                            viewport: viewport,
                        };

                        return page.render(renderContext).promise.then(() => {
                            const imagePromises = convertedImages.filter(img => img.page === i).map(img => {
                                return new Promise((resolve, reject) => {
                                    const image = new Image();
                                    image.crossOrigin = 'anonymous';

                                    // Set timeout for image loading
                                    const timeout = setTimeout(() => {
                                        reject(new Error(`Image loading timeout for page ${i}`));
                                    }, 10000); // 10 second timeout

                                    image.onload = () => {
                                        clearTimeout(timeout);
                                        try {
                                            context.drawImage(image, img.x, img.y, 180, 90);
                                            resolve();
                                        } catch (error) {
                                            clearTimeout(timeout);
                                            console.error(`Error drawing image on page ${i}:`, error);
                                            reject(error);
                                        }
                                    };

                                    image.onerror = (error) => {
                                        clearTimeout(timeout);
                                        console.error(`Error loading image for page ${i}:`, error);
                                        // Try to convert blob URL to base64 if it's a blob URL
                                        if (img.src && img.src.startsWith('blob:')) {
                                            convertToBase64(img.src)
                                                .then(base64Url => {
                                                    const fallbackImage = new Image();
                                                    fallbackImage.onload = () => {
                                                        try {
                                                            context.drawImage(fallbackImage, img.x, img.y, 180, 90);
                                                            resolve();
                                                        } catch (err) {
                                                            console.error(`Error drawing fallback image:`, err);
                                                            reject(err);
                                                        }
                                                    };
                                                    fallbackImage.onerror = () => {
                                                        console.error(`Fallback image also failed to load`);
                                                        reject(new Error(`Failed to load signature image for page ${i}`));
                                                    };
                                                    fallbackImage.src = base64Url;
                                                })
                                                .catch(err => {
                                                    console.error(`Failed to convert blob URL to base64:`, err);
                                                    reject(err);
                                                });
                                        } else {
                                            reject(new Error(`Invalid image source for page ${i}`));
                                        }
                                    };

                                    // Images should now be base64 data URLs, but handle both cases
                                    if (img.src) {
                                        image.src = img.src;
                                    } else {
                                        clearTimeout(timeout);
                                        reject(new Error(`No image source provided for page ${i}`));
                                    }
                                });
                            });

                            return Promise.all(imagePromises).then(() => {
                                return new Promise((resolve, reject) => {
                                    try {
                                        canvas.toBlob((blob) => {
                                            if (!blob) {
                                                reject(new Error('Failed to convert canvas to blob'));
                                                return;
                                            }
                                            const reader = new FileReader();
                                            reader.onloadend = () => {
                                                resolve(reader.result);
                                            };
                                            reader.onerror = () => {
                                                reject(new Error('Failed to read blob as data URL'));
                                            };
                                            reader.readAsDataURL(blob);
                                        }, 'image/png');
                                    } catch (error) {
                                        reject(error);
                                    }
                                });
                            });
                        });
                    })
                );
            }

            const pages = await Promise.all(promises);

            pages.forEach((imgData, index) => {
                if (index !== 0) {
                    pdfDoc.addPage();
                }
                pdfDoc.addImage(imgData, 'PNG', 0, 0, 210, 297);
            });

            // Convert jsPDF to Blob
            const blob = pdfDoc.output('blob');
            let downloadDocName = initialFile.url.split('/')
            downloadDocName = downloadDocName[downloadDocName.length - 1]
            await uploadSignedPDF(initialFile, `signed_${downloadDocName}`, blob)
            // pdfDoc.save(`signed_${downloadDocName}`);
            // Clear images array after successful upload
            setImages([]);
            dispatch(hideAuthLoader());

        } catch (error) {
            console.error('Error in downloadPDF:', error);
            message.error('Failed to generate signed PDF. Please try again.');
            dispatch(hideAuthLoader());
        }
    };


    //Next & Previous page functins:
    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
        }
    };

    const onChange = (e) => {
        setChecked(e.target.checked);
    };

    const removeUploadedSignature = () => {
        setUploadedSignature(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const handleSaveSignature = (dataUrl) => {
        setUploadedSignature(dataUrl);
        // setUploadedSignature(URL.createObjectURL(file));
        setPosition({ top: 50, left: 50 });
        // Store as base64 data URL (dataUrl should already be base64 from SignaturePad)
        localStorage.setItem('signatu', dataUrl)

    };
    // useEffect(() => {
    //     setUploadedSignature(localStorage.getItem('signatu'))
    // }, [isSignedAnyDoc])
    return (
        <>
            <div className='signed_docs'>
                <div style={{
                    display: uploadedSignature !== null ? 'none' : 'block'
                }}>

                    {/* <div

                    className="radio-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginBottom: '20px',
                     }}>
                    <label style={{
                        display: 'flex', alignItems: 'center', gap: '5px',


                    }}>
                        <input
                            type="radio"
                            value="draw"
                            checked={selectedOption === "draw"}
                            onChange={() => {
                                setSelectedOption("draw")
                            }}
                            disabled={signAttch}

                        />
                        Draw Signature
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>

                        <input
                            type="radio"
                            value="upload"
                            checked={selectedOption === "upload"}
                            onChange={() => {
                                setSelectedOption("upload")
                            }
                            }

                        />
                        Upload Signature
                    </label>
                </div> */}
                    {/* <div  className="radio-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginBottom: '20px', */}
                    {/* }}> */}
                    {/* <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}> */}

                    {/* <input
    type="radio"
    value="upload"
    checked={selectedOption === "upload"}
    onChange={() => {
        setSelectedOption("upload")
    }
    }

/> */}
                    {/* Upload Signature */}
                    {/* </label> */}
                    {/* </div> */}
                    <div className='form_row'>

                        {/* {selectedOption == 'draw' ?
                        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}
                        >

                            <SignaturePad onSave={handleSaveSignature} />
                        </div> :
                        <> */}
                        {/* <label>Draw Signature</label> */}
                        <div className="file-upload-container" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <label
                                className="file-upload-box"
                            >
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    onChange={handleFileUpload}
                                    accept=".jpg, .jpeg, .png, .svg"
                                    className="file-input"
                                />
                                <p className="file-upload-text">{fileName != "" ? fileName : "Click to upload an image"}</p>
                            </label>
                            {localStorage.getItem('signatu') && !uploadedSignature && (
                                <Button
                                    type="dashed"
                                    onClick={() => {
                                        setUploadedSignature(localStorage.getItem('signatu'));
                                        setPosition({ top: 50, left: 50 });
                                    }}
                                    style={{ width: 'fit-content', alignSelf: 'center' }}
                                >
                                    Place Saved Signature
                                </Button>
                            )}
                        </div>

                        {/* </>} */}
                        {fileError && <span style={{ color: 'red' }}>{fileError}</span>}  {/* Display error message if fileError state is not empty */}

                    </div>
                </div>
                <div
                    className='uploaded_form'
                    onMouseDown={handleCanvasMouseDown}
                    onMouseUp={handleCanvasMouseUp}
                    onMouseMove={handleCanvasMouseMove}
                >
                    <canvas ref={containerRef} ></canvas>
                    {uploadedSignature && (
                        <> <img
                            src={uploadedSignature}
                            style={{
                                position: 'absolute',
                                top: position.top,
                                left: position.left,
                                zIndex: 9999,
                                width: 150,
                                height: 80,
                                padding: "3px",
                                border: isMouseDown ? '1px solid red' : '1px solid green',
                                cursor: 'move',
                            }}
                            alt="uploaded signature"
                            onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = noImageFound; }}
                        />
                            <button
                                className='ok_btn btn_main'
                                style={{
                                    position: 'absolute',
                                    top: position.top - 10,
                                    left: position.left + 140, // Adjust the position values according to your needs
                                    zIndex: 10000,
                                    border: 'none',
                                    borderRadius: '50px'

                                }}
                                onClick={removeUploadedSignature}>X</button>
                            <button
                                className='close_btn btn_main'
                                style={{
                                    position: 'absolute',
                                    top: position.top - 10,
                                    left: position.left - 10, // Adjust the position values according to your needs
                                    zIndex: 10000,
                                    border: 'none',
                                    borderRadius: '50px'

                                }}
                                onClick={fixImage}>&#10003;</button>
                        </>

                    )}

                    <div className='navigation_signdocs'>
                        <Button className='nav-btn prev' onClick={prevPage} disabled={currentPage === 1}>
                            <FaChevronLeft />
                        </Button>
                        <Button className='nav-btn' onClick={nextPage} disabled={currentPage === totalPages}>
                            <FaChevronRight />
                        </Button>
                    </div>
                </div>
                <div className='signdocs-btn'>Pages: {currentPage} / {totalPages}</div>
                <div className='signdocs-btn' style={{ marginBottom: '2%' }}>
                    <Checkbox checked={checked} onChange={onChange}>I have read all the documents carefully</Checkbox>

                    <Button type='primary' disabled={!(checked)} onClick={downloadPDF}>Submit</Button>
                </div>

            </div>
            <button
                className='floating-btn'
                onClick={() => setReloadPDF(!reloadPDF)}
                style={{
                    position: 'fixed',
                    bottom: '70px',
                    right: '20px',
                    zIndex: 1000,
                    padding: '15px 15px',
                    backgroundColor: ' #007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.2)',
                    transition: 'background-color 0.3s'
                }}
            >
                <ReloadOutlined style={{ fontSize: '20px' }} />
            </button>
        </>
    );
};

export default SignDocs;
